import { CategoriesMenuEffects } from './categories-menu.effects';

export const effects: any[] = [CategoriesMenuEffects];
